import { useQuery } from '@tanstack/react-query';
import { getCurrentTournamentAPI } from '../apis/tournamentsAPI.ts';

export const useCurrentTournamentAPIQuery = () =>
  useQuery({
    queryKey: ['currentTournament'],
    queryFn: () => getCurrentTournamentAPI(),
    refetchInterval: 5000,
  });
